import React from 'react';
import { CitationList } from 'components/Citations/CitationList';
import { extractQuestionCitationIndices, QuestionText } from 'utils/questionMarkdown';

import { Button } from '../../ui/button';
import type { CustomScreenComponentProps } from './types';

export const GenericInfoScreen: React.FC<CustomScreenComponentProps> = ({
  question,
  metadata,
  isSubmitting,
  onComplete,
}) => {
  const metaTitle = metadata?.['title'];
  const hasMetadataTitle = typeof metaTitle === 'string' && metaTitle.trim().length > 0;
  const title = hasMetadataTitle ? metaTitle as string : question.header;
  const metaBody = metadata?.['body'];
  const hasMetadataBody = typeof metaBody === 'string';
  const bodyCopy = hasMetadataBody ? metaBody as string : question.text;
  const authoredTitle = !hasMetadataTitle;
  const authoredBody = !hasMetadataBody;
  const citationIndices = extractQuestionCitationIndices([authoredTitle ? title : null, authoredBody ? bodyCopy : null]);
  const metaCtaLabel = metadata?.['cta_label'];
  const ctaLabel =
    typeof metaCtaLabel === 'string' && metaCtaLabel.trim().length > 0
      ? metaCtaLabel
      : 'Continue';

  return (
    <div className="flex flex-col gap-6">
      {title ? <h3 className="text-lg font-semibold text-foreground">
        {authoredTitle ? <QuestionText text={title} citations={question.citations} inline answerReferences /> : title}
      </h3> : null}
      {bodyCopy ? authoredBody
        ? <QuestionText text={bodyCopy} citations={question.citations} className="text-muted-foreground" answerReferences />
        : <p className="text-sm leading-6 text-muted-foreground">{bodyCopy}</p> : null}
      {(authoredTitle || authoredBody) && <CitationList citations={question.citations} usedIndices={citationIndices} className="px-0 pb-0" />}
      <div>
        <Button onClick={() => onComplete()} disabled={isSubmitting} type="button">
          {ctaLabel}
        </Button>
      </div>
    </div>
  );
};
